<ng-template #container></ng-template>
<floating-knowledgebank-navigation></floating-knowledgebank-navigation>
